<template>
  <div>
    <v-btn
      v-if="isMobile()"
      @click="irEmissaoPedido()"
      fab
      right
      bottom
      fixed
      color="primary"
      large
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-btn
      v-else
      @click="irEmissaoPedido()"
      color="info"
      height="33"
      rounded
      large
    >
      <v-icon left>mdi-plus</v-icon>
      Novo pedido
    </v-btn>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState("usuario", ["usuarioLogado"]),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    irEmissaoPedido() {      
      if (this.usuarioLogado.vendedor_coasul) {
        this.$router.push("/selecionar-tipo-pedido/emissao");
      } else {
        this.$router.push("/novo-pedido");
      }
    },
  },
};
</script>

<style>
</style>